<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13.3333 14H2.66667V6.66667H4V12.6667H12V6.66667H13.3333V14ZM2 2H14V6H2V2ZM6.33333 7.33333H9.66667C9.85333 7.33333 10 7.48 10 7.66667V8.66667H6V7.66667C6 7.48 6.14667 7.33333 6.33333 7.33333ZM3.33333 3.33333V4.66667H12.6667V3.33333H3.33333Z" fill="currentColor"/>
</svg>
